// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___nuhqA","info-panel":"style__info-panel___dnjYD","info-panel__heading":"style__info-panel__heading___2yX7t","info-panel__text-container":"style__info-panel__text-container___2BDCq","info-panel__sub-heading":"style__info-panel__sub-heading___1n-8A","info-panel__text":"style__info-panel__text___1rKdg","text-link":"style__text-link___1MSyM"};


//////////////////
// WEBPACK FOOTER
// ./components/MarketingInfo/style.scss
// module id = 1379
// module chunks = 0